import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../public/images/gambeat_logo_black_full.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "column items-center text-weight-bolder text-uppercase q-mb-md",
  style: {"font-size":"26px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "150",
    height: "30"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "column items-center q-mb-lg",
  style: {"color":"var(--gray-raven)"}
}, " Authorize to the platform ", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center q-mb-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (!_ctx.hideNav)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_tabs, {
            shrink: "",
            dense: "",
            "inline-label": "",
            "content-class": "no-border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_route_tab, {
                name: "Log in",
                label: "Log in",
                "content-class": "flex inline",
                to: `/login${_ctx.getReferrerParamsStr()}`,
                "no-caps": "",
                "inline-label": "",
                exact: ""
              }, null, 8, ["to"]),
              _createVNode(_component_q_route_tab, {
                name: "Sign up",
                label: "Sign up",
                "content-class": "flex inline",
                to: `/sign-up${_ctx.getReferrerParamsStr()}`,
                "no-caps": "",
                "inline-label": "",
                exact: ""
              }, null, 8, ["to"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}